import { render } from "./Allowance.vue?vue&type=template&id=53f86678"
import script from "./Allowance.vue?vue&type=script&lang=js"
export * from "./Allowance.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/tom/tom/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__